(() => {
  const ITEM_SELECTOR = '#octane-quiz-wrapper [data-element="oct-quiz-resultitem"]';
  const PLAN_RADIO = 'input[name^="selling_plans_"]';
  const PRICE_PATTERN = /\(?\s*(\$[\d,]+(?:\.\d+)?)\s*\)?/;
  const CODES_KEY = 'swCartDiscountCodes';
  const items = new WeakMap();
  let quizCode = '';
  let autoApply = false;

  const formatPrice = (price) => price.replace(/\.00$/, '');
  const planNumber = (text) => parseInt(text.replace(/\D/g, ''), 10) || Infinity;

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function plansWrapper(item) {
    return item.querySelector(PLAN_RADIO)?.closest('label')?.parentElement?.parentElement?.parentElement || null;
  }

  function setup(item) {
    if (items.has(item)) return;

    const image = item.querySelector('[data-element="oct-quiz-resultitemImg"]');
    const copy = image?.parentElement?.nextElementSibling;
    const title = copy?.querySelector(':scope > a');
    if (!title) return;

    const siblings = [...copy.children];
    const [meta, description, price] = siblings.slice(siblings.indexOf(title) + 1);
    const state = { title, extras: null, observer: null };
    items.set(item, state);

    item.classList.add('sw-qr-item');
    copy.classList.add('sw-qr-copy');
    title.classList.add('sw-qr-title');
    meta?.classList.add('sw-qr-meta');
    description?.classList.add('sw-qr-desc');
    price?.classList.add('sw-qr-price');

    state.observer = new MutationObserver(() => refresh(item));
    refresh(item);
    loadExtras(item, state);
  }

  function refresh(item) {
    const state = items.get(item);
    state.observer.disconnect();
    try {
      preselectPlan(item, state);
      decorate(item, state);
    } finally {
      state.observer.observe(item, { childList: true, subtree: true });
    }
  }

  // Octane only auto-selects a plan when a product has exactly one, so the subscribe default leaves add to cart disabled.
  function preselectPlan(item, state) {
    const select = plansWrapper(item)?.querySelector('select');
    if (!select || select.value !== '-1') return;

    const options = [...select.options].filter((option) => option.value !== '-1');
    const option =
      options.find((candidate) => candidate.value === state.extras?.dataset.planId) ||
      options.sort((a, b) => planNumber(a.text) - planNumber(b.text))[0];
    if (!option) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function decorate(item, state) {
    const wrapper = plansWrapper(item);
    const radios = [...item.querySelectorAll(PLAN_RADIO)];
    const oneTime = radios.find((radio) => radio.value === 'false');
    const subscribe = radios.find((radio) => radio.value === 'true');
    const oneTimePrice = oneTime ? (oneTime.closest('label').textContent.match(PRICE_PATTERN) || [])[1] : '';
    const data = state.extras?.dataset || {};

    radios.forEach((radio) => {
      const isSubscribe = radio === subscribe;
      const label = radio.closest('label');
      const option = label.parentElement;
      option.classList.add('sw-qr-opt', isSubscribe ? 'sw-qr-opt--sub' : 'sw-qr-opt--once');
      option.classList.toggle('is-checked', radio.checked);
      option.parentElement.classList.add('sw-qr-opts');

      const name = relabel(label, isSubscribe ? oneTimePrice : '');
      const wanted = isSubscribe
        ? data.subTitle && (data.planPct ? `${data.subTitle} (${data.planPct}% OFF)` : data.subTitle)
        : data.onceTitle;
      if (wanted && name.textContent !== wanted) name.textContent = wanted;

      const perks = state.extras?.querySelector('template.sw-qr-extras__perks');
      if (isSubscribe && perks && !option.querySelector('.sw-qr-perks')) option.append(perks.content.cloneNode(true));
    });

    const subscribeOption = subscribe?.closest('label').parentElement;
    if (subscribeOption?.previousElementSibling) subscribeOption.parentElement.prepend(subscribeOption);

    const select = wrapper?.querySelector('select');
    wrapper?.classList.add('sw-qr-plans');
    if (select) [...wrapper.children].find((child) => child.contains(select))?.classList.add('sw-qr-freq');

    const button = [...item.querySelectorAll('button')].find((candidate) => !candidate.closest('.sw-qr-extras'));
    button?.parentElement.classList.add('sw-qr-atc');
    button?.parentElement.parentElement.classList.add('sw-qr-actions');

    item.classList.toggle('sw-qr-ready', radios.length > 0 && (!select || select.value !== '-1'));
  }

  function relabel(label, comparePrice) {
    const existing = label.querySelector('.sw-qr-opt__name');
    if (existing) return existing;

    const textNodes = [...label.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE);
    const text = textNodes.map((node) => node.textContent).join('').trim();
    const price = (text.match(PRICE_PATTERN) || [])[1] || '';
    const name = element('span', 'sw-qr-opt__name', text.replace(PRICE_PATTERN, '').trim());
    const priceNode = element('span', 'sw-qr-opt__price', price && formatPrice(price));
    if (price && comparePrice && comparePrice !== price) priceNode.append(element('s', '', formatPrice(comparePrice)));

    // Octane styles every direct child span of the label as the radio circle, so the text needs a non-span wrapper.
    const wrapper = element('strong', 'sw-qr-opt__text');
    wrapper.append(name, priceNode);

    if (textNodes.length) {
      textNodes[0].replaceWith(wrapper);
      textNodes.slice(1).forEach((node) => node.remove());
    } else {
      label.append(wrapper);
    }
    return name;
  }

  function decorateCode() {
    document.querySelectorAll('#octane-quiz-wrapper [data-element~="oct-quiz-heading"]').forEach((heading) => {
      if (heading.querySelector('.sw-qr-code')) return;

      const text = heading.textContent.trim();
      const code = quizCode && text.includes(quizCode) ? quizCode : (text.match(/code:\s*([A-Z0-9-]{4,})$/i) || [])[1];
      if (!code) return;

      const label = text.slice(0, text.indexOf(code)).replace(/[:\s]+$/, '');
      const box = element('div', 'sw-qr-code');
      if (label) box.append(element('p', 'sw-qr-code__label', label));

      const button = element('button', 'sw-qr-code__value');
      button.type = 'button';
      button.setAttribute('aria-label', `Copy code ${code}`);
      const action = element('span', 'sw-qr-code__action', 'Copy');
      action.setAttribute('aria-live', 'polite');
      button.append(element('span', 'sw-qr-code__text', code), action);
      button.addEventListener('click', () => {
        navigator.clipboard
          ?.writeText(code)
          .then(() => {
            action.textContent = 'Copied';
            setTimeout(() => (action.textContent = 'Copy'), 2000);
          })
          .catch(() => {});
      });

      box.append(button);
      heading.replaceChildren(box);
    });
  }

  function loadExtras(item, state) {
    const url = new URL(state.title.href, window.location.origin);
    fetch(`${url.pathname}?section_id=sw-quiz-product-extras`)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const extras = new DOMParser().parseFromString(html, 'text/html').querySelector('.sw-qr-extras');
        if (!extras) return;

        state.extras = extras;
        state.title.after(extras);
        item.classList.add('sw-qr-has-extras');
        refresh(item);
        window.yotpoWidgetsContainer?.initWidgets?.();
      })
      .catch(() => {});
  }

  // Octane applies the quiz code with its own request after firing addToCart, so wait for it before rendering the drawer.
  async function cartWithQuizCode() {
    const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
    for (let attempt = 0; ; attempt++) {
      const cart = await fetch(cartUrl).then((response) => response.json());
      const applied = cart.discount_codes?.some((discount) => discount.code.toLowerCase() === quizCode.toLowerCase());
      if (applied) rememberQuizCode();
      if (applied || !quizCode || !autoApply || attempt >= 5) return cart;
      await new Promise((resolve) => setTimeout(resolve, 300));
    }
  }

  // sw-cart-discount resends the full code set on every apply and only knows codes it applied, so record this one or a later drawer code would drop it.
  function rememberQuizCode() {
    try {
      const codes = JSON.parse(window.sessionStorage.getItem(CODES_KEY) || '[]');
      if (codes.some((code) => code.toLowerCase() === quizCode.toLowerCase())) return;
      window.sessionStorage.setItem(CODES_KEY, JSON.stringify([...codes, quizCode]));
    } catch (error) {
      /* private mode */
    }
  }

  async function refreshCart() {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart?.renderContents) return;

    try {
      const cart = await cartWithQuizCode();
      const ids = miniCart.getSectionsToRender().map((section) => section.id);
      const sections = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`).then((response) =>
        response.json()
      );
      miniCart.renderContents({ sections });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'octane-quiz' } }));
    } catch (error) {
      console.error(error);
    }
  }

  document.addEventListener('octane.quiz.completed', (event) => {
    const info = event.detail?.state?.info || {};
    quizCode = info.discount_code || quizCode;
    autoApply = Boolean(info.auto_apply_to_cart);
    document.querySelectorAll(ITEM_SELECTOR).forEach(setup);
    decorateCode();
  });

  document.addEventListener('octane.quiz.addToCart', refreshCart);

  document.querySelectorAll(ITEM_SELECTOR).forEach(setup);
})();
